import './Map.css';
import { MapContainer, TileLayer, Rectangle} from 'react-leaflet'

const Map = ({ bbox }) => {
    const {swlng, swlat, nelng, nelat} = bbox
    // const xy = Object.values(bbox).map(x => Number(x))
    // console.log(xy)
    const blackOptions = { color: '#AD6A30', fillColor: '#AD6A30' }
    const rectangle = [
        [Number(nelat), Number(nelng), ],
        [Number(swlat), Number(swlng)],
    ]
    console.log(rectangle)
    
    const position =    [(Number(swlat) + Number(swlat))/2, (Number(swlng) + Number(nelng))/2] 
    

    return (
        <MapContainer center={position} bounds={rectangle} scrollWheelZoom={false}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Rectangle bounds={rectangle} pathOptions={blackOptions} />
        </MapContainer>
    )
}

export default Map